import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getLeaderboard } from "../../actions/formationLearner.actions";
import {
  Newspaper,
  Award,
  GraduationCap,
  Wrench,
  Shield,
  BookOpenCheck,
  BookOpen,
  Map,
  Milestone,
  ExternalLink,
  Users,
  LogOut,
} from "lucide-react";
import Logout from "../Log/Logout";
import TeamModal from "./TeamModal";
import Equipe from "../../asset/equipe.png";

const ACADEMY_RING_C = 2 * Math.PI * 15;

const Menu = () => {
  const userData = useSelector((state) => state.userReducer);
  const location = useLocation();
  const dispatch = useDispatch();

  const [showTrending, setShowTrending] = useState(false);
  const [showAssistantesModal, setShowAssistantesModal] = useState(false);
  const [showRoadMap, setShowRoadMap] = useState(false);
  const [academyPct, setAcademyPct] = useState(null);

  // Progression globale Skills Academy (formations terminées / publiées)
  useEffect(() => {
    let active = true;
    dispatch(getLeaderboard())
      .then((d) => {
        if (!active || !d || !d.me || !d.me.totalPublished) return;
        setAcademyPct(
          Math.min(100, Math.round((d.me.completed / d.me.totalPublished) * 100))
        );
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [dispatch]);

  const isActive = (path) => {
    const match =
      path === "/"
        ? location.pathname === "/" || location.pathname === "/home"
        : location.pathname.startsWith(path);
    return match ? "active" : "";
  };

  const closeAssistantesModal = () => {
    setShowAssistantesModal(false);
  };

  const closeRoadMap = () => {
    setShowRoadMap(false);
  };

  return (
    <div className="leftBlock">
      <div className="left_menu">
        <p className="menu-label">Menu</p>
        <Link className={`menu-item ${isActive("/")}`} to={`/`}>
          <Newspaper size={17} /> Fil d'actualités
        </Link>
        <Link
          className={`menu-item ${isActive(`/userprofil/${userData.id}`)}`}
          to={`/userprofil/${userData.id}`}
        >
          <Award size={17} /> Mes compétences
        </Link>
        <Link
          className={`menu-item ${isActive("/tutoriels")}`}
          to={`/tutoriels`}
        >
          <GraduationCap size={17} /> Les tutoriels
        </Link>
        <Link className={`menu-item ${isActive("/formations")}`} to={`/formations`}>
          <BookOpen size={17} />
          <span className="skills-academy">
            <span className="sa-skills">Skills</span> Academy
          </span>
          {academyPct !== null && (
            <span
              className="menu-academy-ring"
              title={`${academyPct}% terminé`}
            >
              <svg viewBox="0 0 36 36" aria-hidden="true">
                <defs>
                  <linearGradient
                    id="menuAcademyRingGrad"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#ffd166" />
                    <stop offset="100%" stopColor="#f7a600" />
                  </linearGradient>
                </defs>
                <circle className="menu-academy-ring-track" cx="18" cy="18" r="15" />
                <circle
                  className="menu-academy-ring-bar"
                  cx="18"
                  cy="18"
                  r="15"
                  style={{
                    strokeDasharray: ACADEMY_RING_C,
                    strokeDashoffset: ACADEMY_RING_C * (1 - academyPct / 100),
                  }}
                />
              </svg>
              <span className="menu-academy-ring-val">{academyPct}%</span>
            </span>
          )}
        </Link>
        <Link
          className={`menu-item ${isActive("/convertisseur")}`}
          to={`/convertisseur`}
        >
          <Wrench size={17} /> Mes outils
        </Link>

        <p className="menu-label">Ressources</p>
        <button
          className="menu-item"
          onClick={() => setShowAssistantesModal(true)}
        >
          <Map size={17} /> Carte des assistantes
        </button>
        <button className="menu-item" onClick={() => setShowRoadMap(true)}>
          <Milestone size={17} /> Roadmap
        </button>
        <a
          className="menu-item"
          href="https://www.figma.com/proto/gddXGBbXLsxT5sdpOFlN6p/Suivi-des-MEPs?node-id=1-2&t=shBZwR1JwDqZN11y-1&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=90%3A394"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ExternalLink size={17} /> Suivi M.E.P
        </a>

        {(userData.isAdmin || userData.isReferent) && (
          <p className="menu-label">Gestion</p>
        )}
        {userData.isAdmin ? (
          <Link className="button-admin" to={`/dashboard`}>
            <Shield size={16} /> Administration
          </Link>
        ) : null}
        {userData.isReferent ? (
          <Link
            className={`menu-item ${isActive("/requestKnowledge")}`}
            to={`/requestKnowledge`}
          >
            <BookOpenCheck size={17} /> Référent Tutoriels
          </Link>
        ) : null}

        <div className="equipeproductions">
          <img src={Equipe} alt="equipe" className="show-equipe" />
          <button className="menu-item" onClick={() => setShowTrending(true)}>
            <Users size={17} /> Équipe Production
          </button>
        </div>

        <div className="menu-item menu-logout">
          <Logout icon={<LogOut size={17} />} />
        </div>

        <TeamModal open={showTrending} onClose={() => setShowTrending(false)} />
        {showAssistantesModal &&
          ReactDOM.createPortal(
            <div className="modal">
              <div
                className="modal-content full-width-modal"
                style={{ position: "relative" }}
              >
                <button className="close-button" onClick={closeAssistantesModal}>
                  <i className="fa-regular fa-circle-xmark"></i>
                </button>
                <h2>Carte des assistantes</h2>
                <div style={{ width: "auto" }}>
                  <div
                    style={{
                      position: "relative",
                      paddingBottom: "56.25%",
                      paddingTop: 0,
                      height: 0,
                    }}
                  >
                    <iframe
                      title="Genially sans titre"
                      frameBorder="0"
                      width="1200px"
                      height="675px"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                      src="https://view.genial.ly/65aa7383cb64fc0014c305af"
                      type="text/html"
                      allowscriptaccess="always"
                      allowfullscreen="true"
                      scrolling="yes"
                      allownetworking="all"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>,
            document.body
          )}

        {showRoadMap &&
          ReactDOM.createPortal(
            <div className="modal">
              <div
                className="modal-content full-width-modal"
                style={{ position: "relative" }}
              >
                <button className="close-button" onClick={closeRoadMap}>
                  <i className="fa-regular fa-circle-xmark"></i>
                </button>
                <h2>Roadmap</h2>
                <div style={{ width: "auto" }}>
                  <div
                    style={{
                      position: "relative",
                      paddingBottom: "56.25%",
                      paddingTop: 0,
                      height: 0,
                    }}
                  >
                    <iframe
                      title="Genially sans titre"
                      frameBorder="0"
                      width="1200px"
                      height="675px"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                      src="https://view.genially.com/67fe524706f36b7cf8121028"
                      type="text/html"
                      allowscriptaccess="always"
                      allowfullscreen="true"
                      scrolling="yes"
                      allownetworking="all"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

export default Menu;
